"use client";
import { Box, TypographyStylesProvider } from "@mantine/core";

export default function PrivacyLayout() {
  return (
    <>
      <Box mt="100px">
        <TypographyStylesProvider>
          <div
            dangerouslySetInnerHTML={{
              __html:
                "\n" +
                "<div class=WordSection1>\n" +
                "\n" +
                "<p class=MsoNormal align=center style='text-align:center'><span\n" +
                "style='font-size:11.0pt;font-family:\"Arial\",sans-serif'>PRIVACY POLICY</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Times\",serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>Effective date:\n" +
                "05/12/2022</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>1.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Introduction</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Welcome to&nbsp;<b>Stacks\n" +
                "on Stacks LLC</b>.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Stacks on Stacks\n" +
                "LLC&nbsp;(“us”, “we”, or “our”)\n" +
                "operates&nbsp;https://stacks-on-stacks.com&nbsp;(hereinafter referred to as “<b>Service</b>”).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Our Privacy\n" +
                "Policy governs your visit to&nbsp;https://stacks-on-stacks.com, and explains\n" +
                "how we collect, safeguard and disclose information that results from your use\n" +
                "of our Service. </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We use your data\n" +
                "to provide and improve Service. By using Service, you agree to the collection\n" +
                "and use of information in accordance with this policy. Unless otherwise defined\n" +
                "in this Privacy Policy, the terms used in this Privacy Policy have the same\n" +
                "meanings as in our Terms and Conditions.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Our Terms and\n" +
                "Conditions (“<b>Terms</b>”) govern all use of our Service and together with the\n" +
                "Privacy Policy constitutes your agreement with us (“<b>agreement</b>”).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>2.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Definitions</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>SERVICE&nbsp;</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>means\n" +
                "the&nbsp;https://stacks-on-stacks.com website&nbsp;operated by&nbsp;Stacks on\n" +
                "Stacks LLC.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>PERSONAL DATA</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;means data about a living\n" +
                "individual who can be identified from those data (or from those and other\n" +
                "information either in our possession or likely to come into our possession).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>USAGE DATA</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;is data collected automatically\n" +
                "either generated by the use of Service or from Service infrastructure itself\n" +
                "(for example, the duration of a page visit).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>COOKIES</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;are small files stored on your\n" +
                "device (computer or mobile device).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>DATA\n" +
                "CONTROLLER</span></b><span style='font-family:\"Arial\",sans-serif'>&nbsp;means a\n" +
                "natural or legal person who (either alone or jointly or in common with other\n" +
                "persons) determines the purposes for which and the manner in which any personal\n" +
                "data are, or are to be, processed. For the purpose of this Privacy Policy, we\n" +
                "are a Data Controller of your data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>DATA\n" +
                "PROCESSORS (OR SERVICE PROVIDERS)</span></b><span style='font-family:\"Arial\",sans-serif'>&nbsp;means\n" +
                "any natural or legal person who processes the data on behalf of the Data\n" +
                "Controller. We may use the services of various Service Providers in order to\n" +
                "process your data more effectively.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>DATA\n" +
                "SUBJECT&nbsp;</span></b><span style='font-family:\"Arial\",sans-serif'>is any\n" +
                "living individual who is the subject of Personal Data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>THE USER&nbsp;</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>is the individual using our Service. The\n" +
                "User corresponds to the Data Subject, who is the subject of Personal Data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>3.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Information Collection and Use</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We collect\n" +
                "several different types of information for various purposes to provide and\n" +
                "improve our Service to you.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>4.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Types of Data Collected</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>Personal Data</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>While using our\n" +
                "Service, we may ask you to provide us with certain personally identifiable information\n" +
                "that can be used to contact or identify you (“<b>Personal Data</b>”).\n" +
                "Personally identifiable information may include, but is not limited to:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(a)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Email address</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>Usage Data</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We may also\n" +
                "collect information that your browser sends whenever you visit our Service or\n" +
                "when you access Service by or through a mobile device (“<b>Usage Data</b>”).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>This Usage Data\n" +
                "may include information such as your computer's Internet Protocol address (e.g.\n" +
                "IP address), browser type, browser version, the pages of our Service that you\n" +
                "visit, the time and date of your visit, the time spent on those pages, unique\n" +
                "device identifiers and other diagnostic data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>When you access\n" +
                "Service with a mobile device, this Usage Data may include information such as\n" +
                "the type of mobile device you use, your mobile device unique ID, the IP address\n" +
                "of your mobile device, your mobile operating system, the type of mobile\n" +
                "Internet browser you use, unique device identifiers and other diagnostic data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:14.2pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>Tracking\n" +
                "Cookies Data</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We use cookies\n" +
                "and similar tracking technologies to track the activity on our Service and we\n" +
                "hold certain information.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Cookies are files\n" +
                "with a small amount of data which may include an anonymous unique identifier.\n" +
                "Cookies are sent to your browser from a website and stored on your device.\n" +
                "Other tracking technologies are also used such as beacons, tags and scripts to\n" +
                "collect and track information and to improve and analyze our Service.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>You can instruct\n" +
                "your browser to refuse all cookies or to indicate when a cookie is being sent.\n" +
                "However, if you do not accept cookies, you may not be able to use some portions\n" +
                "of our Service.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Examples of\n" +
                "Cookies we use:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(a)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Session Cookies:</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;We use Session Cookies to operate\n" +
                "our Service.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(b)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Preference Cookies:</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;We use Preference Cookies to\n" +
                "remember your preferences and various settings.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(c)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Security Cookies:</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;We use Security Cookies for\n" +
                "security purposes.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(d)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Advertising Cookies:</span></b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;Advertising Cookies are used to\n" +
                "serve you with advertisements that may be relevant to you and your interests.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>5.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Use of Data</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Stacks on Stacks\n" +
                "LLC&nbsp;uses the collected data for various purposes:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(a)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to provide and maintain our Service;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(b)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to notify you about changes to our\n" +
                "Service; </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(c)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to allow you to participate in\n" +
                "interactive features of our Service when you choose to do so; </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(d)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to provide customer support; </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(e)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to gather analysis or valuable\n" +
                "information so that we can improve our Service; </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(f)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to monitor the usage of our Service;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(g)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to detect, prevent and address technical\n" +
                "issues;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(h)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to fulfill any other purpose for which\n" +
                "you provide it;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(i)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to carry out our obligations and enforce\n" +
                "our rights arising from any contracts entered into between you and us,\n" +
                "including for billing and collection;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(j)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to provide you with notices about your\n" +
                "account and/or subscription, including expiration and renewal notices,\n" +
                "email-instructions, etc.;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(k)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>to provide you with news, special offers\n" +
                "and general information about other goods, services and events which we offer\n" +
                "that are similar to those that you have already purchased or enquired about\n" +
                "unless you have opted not to receive such information;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(l)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>in any other way we may describe when\n" +
                "you provide the information;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(m)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'> </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>for any other purpose with your consent.\n" +
                "</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>6.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Retention of Data</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We will retain\n" +
                "your Personal Data only for as long as is necessary for the purposes set out in\n" +
                "this Privacy Policy. We will retain and use your Personal Data to the extent\n" +
                "necessary to comply with our legal obligations (for example, if we are required\n" +
                "to retain your data to comply with applicable laws), resolve disputes, and\n" +
                "enforce our legal agreements and policies.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We will also\n" +
                "retain Usage Data for internal analysis purposes. Usage Data is generally\n" +
                "retained for a shorter period, except when this data is used to strengthen the\n" +
                "security or to improve the functionality of our Service, or we are legally\n" +
                "obligated to retain this data for longer time periods.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>7.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Transfer of Data</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Your information,\n" +
                "including Personal Data, may be transferred to – and maintained on – computers\n" +
                "located outside of your state, province, country or other governmental\n" +
                "jurisdiction where the data protection laws may differ from those of your\n" +
                "jurisdiction.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>If you are\n" +
                "located outside United States and choose to provide information to us, please\n" +
                "note that we transfer the data, including Personal Data, to United States and\n" +
                "process it there.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Your consent to\n" +
                "this Privacy Policy followed by your submission of such information represents\n" +
                "your agreement to that transfer.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-top:0in;margin-right:.2pt;margin-bottom:0in;\n" +
                "margin-left:17.85pt;margin-bottom:.0001pt;text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Stacks on Stacks LLC&nbsp;will take all\n" +
                "the steps reasonably necessary to ensure that your data is treated securely and\n" +
                "in accordance with this Privacy Policy and no transfer of your Personal Data\n" +
                "will take place to an organisation or a country unless there are adequate controls\n" +
                "in place including the security of your data and other personal information.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>8.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Disclosure of Data</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We may disclose\n" +
                "personal information that we collect, or you provide:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(a)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Disclosure for Law Enforcement.</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Under certain\n" +
                "circumstances, we may be required to disclose your Personal Data if required to\n" +
                "do so by law or in response to valid requests by public authorities.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:21.3pt'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(b)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Business Transaction.</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>If we or our\n" +
                "subsidiaries are involved in a merger, acquisition or asset sale, your Personal\n" +
                "Data may be transferred.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:21.25pt'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.45pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(c)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span><b><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Other cases. We may disclose your\n" +
                "information also:</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.45pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.75in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(i)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>with your consent in any other cases;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.75in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>9.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp;&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Security of Data</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>The security of\n" +
                "your data is important to us but remember that no method of transmission over\n" +
                "the Internet or method of electronic storage is 100% secure. While we strive to\n" +
                "use commercially acceptable means to protect your Personal Data, we cannot\n" +
                "guarantee its absolute security.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>10.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Your Data Protection Rights Under\n" +
                "General Data Protection Regulation (GDPR)</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>If you are a\n" +
                "resident of the European Union (EU) and European Economic Area (EEA), you have\n" +
                "certain data protection rights, covered by GDPR. – See more at\n" +
                "https://eur-lex.europa.eu/eli/reg/2016/679/oj </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We aim to take\n" +
                "reasonable steps to allow you to correct, amend, delete, or limit the use of\n" +
                "your Personal Data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>If you wish to be\n" +
                "informed what Personal Data we hold about you and if you want it to be removed\n" +
                "from our systems, please email us at info@stacks-on-stacks.com. </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>In certain\n" +
                "circumstances, you have the following data protection rights:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(a)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>the right to access, update or to delete\n" +
                "the information we have on you;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(b)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>the right of rectification. You have the\n" +
                "right to have your information rectified if that information is inaccurate or\n" +
                "incomplete;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(c)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>the right to object. You have the right\n" +
                "to object to our processing of your Personal Data;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(d)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>the right of restriction. You have the\n" +
                "right to request that we restrict the processing of your personal information;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(e)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>the right to data portability. You have\n" +
                "the right to be provided with a copy of your Personal Data in a structured,\n" +
                "machine-readable and commonly used format;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>(f)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>the right to withdraw consent.&nbsp;You\n" +
                "also have the right to withdraw your consent at any time where we rely on your\n" +
                "consent to process your personal information;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Please note that\n" +
                "we may ask you to verify your identity before responding to such requests.\n" +
                "Please note, we may not able to provide Service without some necessary data.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>You have the\n" +
                "right to complain to a Data Protection Authority about our collection and use\n" +
                "of your Personal Data. For more information, please contact your local data\n" +
                "protection authority in the European Economic Area (EEA).</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>11.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Your Data Protection Rights under the\n" +
                "California Privacy Protection Act (CalOPPA)</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>CalOPPA is the\n" +
                "first state law in the nation to require commercial websites and online\n" +
                "services to post a privacy policy. The law’s reach stretches well beyond\n" +
                "California to require a person or company in the United States (and conceivable\n" +
                "the world) that operates websites collecting personally identifiable\n" +
                "information from California consumers to post a conspicuous privacy policy on\n" +
                "its website stating exactly the information being collected and those\n" +
                "individuals with whom it is being shared, and to comply with this policy. – See\n" +
                "more at:\n" +
                "https://consumercal.org/about-cfc/cfc-education-foundation/california-online-privacy-protection-act-caloppa-3/\n" +
                "</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>According to\n" +
                "CalOPPA we agree to the following:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-size:10.0pt;font-family:\"Arial\",sans-serif'>(a)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>users can visit our site anonymously;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-size:10.0pt;font-family:\"Arial\",sans-serif'>(b)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>our Privacy Policy link includes the\n" +
                "word “Privacy”, and can easily be found on the page specified above on the home\n" +
                "page of our website;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-size:10.0pt;font-family:\"Arial\",sans-serif'>(c)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>users will be notified of any privacy\n" +
                "policy changes on our Privacy Policy Page;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:35.7pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-size:10.0pt;font-family:\"Arial\",sans-serif'>(d)</span><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp;&nbsp; </span><span\n" +
                "style='font-family:\"Arial\",sans-serif'>users are able to change their personal\n" +
                "information by emailing us at info@stacks-on-stacks.com. </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:.25in;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Our Policy on “Do\n" +
                "Not Track” Signals:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We honor Do Not\n" +
                "Track signals and do not track, plant cookies, or use advertising when a Do Not\n" +
                "Track browser mechanism is in place. Do Not Track is a preference you can set\n" +
                "in your web browser to inform websites that you do not want to be tracked. </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>You can enable or\n" +
                "disable Do Not Track by visiting the Preferences or Settings page of your web\n" +
                "browser.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>12.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Service Providers</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We may employ\n" +
                "third party companies and individuals to facilitate our Service (“<b>Service\n" +
                "Providers</b>”), provide Service on our behalf, perform Service-related\n" +
                "services or assist us in analysing how our Service is used.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>These third\n" +
                "parties have access to your Personal Data only to perform these tasks on our\n" +
                "behalf and are obligated not to disclose or use it for any other purpose.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>13.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Analytics</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We may use\n" +
                "third-party Service Providers to monitor and analyze the use of our Service.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Umami</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Times\",serif'>Umami</span><span\n" +
                "style='font-family:\"Arial\",sans-serif'> is a web traffic analysis tool.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>For more\n" +
                "information on what type of information Umami collects, please visit their\n" +
                "site: https://umami.is</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>14.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>CI/CD tools</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We may use\n" +
                "third-party Service Providers to automate the development process of our\n" +
                "Service. </span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>GitHub</span></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>GitHub is\n" +
                "provided by GitHub, Inc.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>GitHub is a\n" +
                "development platform to host and review code, manage projects, and build\n" +
                "software.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>For more\n" +
                "information on what data GitHub collects for what purpose and how the\n" +
                "protection of the data is ensured, please visit GitHub Privacy Policy page:<u><span\n" +
                "style='color:blue'> </span></u>https://help.github.com/en/articles/github-privacy-statement.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>15.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Links to Other Sites</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Our Service may\n" +
                "contain links to other sites that are not operated by us. If you click a third\n" +
                "party link, you will be directed to that third party's site. We strongly advise\n" +
                "you to review the Privacy Policy of every site you visit.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We have no\n" +
                "control over and assume no responsibility for the content, privacy policies or\n" +
                "practices of any third party sites or services.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>16.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Children's Privacy</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif;color:black'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>Our Services are\n" +
                "not intended for use by children under the age of 18 (“<b>Child</b>” or “<b>Children</b>”).\n" +
                "</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We do not\n" +
                "knowingly collect personally identifiable information from Children under 18.\n" +
                "If you become aware that a Child has provided us with Personal Data, please\n" +
                "contact us. If we become aware that we have collected Personal Data from\n" +
                "Children without verification of parental consent, we take steps to remove that\n" +
                "information from our servers.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>17.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Changes to This Privacy Policy</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We may update our\n" +
                "Privacy Policy from time to time. We will notify you of any changes by posting\n" +
                "the new Privacy Policy on this page.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>We will let you\n" +
                "know via email and/or a prominent notice on our Service, prior to the change\n" +
                "becoming effective and update “effective date” at the top of this Privacy\n" +
                "Policy.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span\n" +
                "style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>You are advised\n" +
                "to review this Privacy Policy periodically for any changes. Changes to this\n" +
                "Privacy Policy are effective when they are posted on this page.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><b><span style='font-family:\"Arial\",sans-serif'>18.</span></b><b><span\n" +
                "style='font-size:7.0pt;font-family:\"Times\",serif'>&nbsp; </span></b><b><u><span\n" +
                "style='font-family:\"Arial\",sans-serif'>Contact Us</span></u></b></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'>&nbsp;</p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>If you have any\n" +
                "questions about this Privacy Policy, please contact us:</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt;text-align:justify;text-justify:\n" +
                "inter-ideograph'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt'><span style='font-family:\"Arial\",sans-serif'>By\n" +
                "email: info@stacks-on-stacks.com.</span></p>\n" +
                "\n" +
                "<p class=MsoNormal style='margin-left:17.85pt'><span style='font-family:\"Arial\",sans-serif'>&nbsp;</span></p>\n" +
                "\n" +
                "</div>\n",
            }}
          />
        </TypographyStylesProvider>
      </Box>
    </>
  );
}
